<div class="mat-elevation-z8 mat-elevation-z9" [ngClass]="{'no-padding': pageType==='widget'}">
    <div [ngClass]="{'table-responsive': pageType!=='dover-accordion','txt-center': pageType==='dover'}">
        <table mat-table class="mat-elevation-z8 w-100" [dataSource]="dataSource" matSort
            [ngClass]="{'vitals-table': pageType==='vitals'}" [hidden]="!dataSource?.data?.length">
            <ng-container [matColumnDef]="tableData" *ngFor="let tableData of objectKeys(columnHeader)">
                <ng-container *ngIf="columnHeader[tableData] !== 'Action'">
                    <tr>
                        <th scope="col" mat-header-cell *matHeaderCellDef>
                            <span
                                [ngClass]="{'pl-10': tableData==='sourceTimestamp'}">{{columnHeader[tableData]}}</span>
                        </th>
                    </tr>
                    <tr>
                        <td mat-cell *matCellDef="let element; let i=index" title="{{element[tableData]}}"
                            (mouseenter)="element['hover']=true;" (mouseleave)="element['hover']=false;"
                            [class]="getClassOf(element,tableData)">
                            <ng-container [formGroup]="form" *ngIf="pageType==='vitals'">
                                <div>
                                    <ng-container formArrayName="noteDetails">
                                        <ng-container [formGroupName]="i">
                                            <span *ngIf="tableData==='timestamp' || tableData==='sourceTimestamp'"
                                                class="pl-1">
                                                {{element[tableData] | date : 'shortTime'}}
                                            </span>
                                            <span *ngIf="tableData!=='sourceTimestamp' && tableData !=='value' && tableData !=='author'
                                && tableData !=='timestamp'">
                                                <span *ngIf="tableData==='Respiratory Rate'" class="flag-pos">
                                                    <img class=" mx-100 default-img list-img-inn" alt="Flag"
                                                        *ngIf="element['attrValid']"
                                                        src="../../assets/images/table-flag-dover.svg" title="Flag"
                                                        (click)="flagClick(i, element);$event.stopPropagation();" />
                                                    <img class=" mx-100 default-img list-img-inn" alt="Flag"
                                                        *ngIf="element['hover'] && !element['attrValid']"
                                                        src="../../assets/images/hover-flag.svg" title="Flag"
                                                        (click)="flagClick(i, element);$event.stopPropagation();" />
                                                </span>
                                                {{element[tableData]}}
                                            </span>
                                            <ng-container>
                                                <div class="-text-area-field-height">
                                                <mat-form-field appearance="fill" class="dover-form"
                                                    *ngIf="tableData==='value' && !element[tableData]">
                                                    <textarea matInput formControlName="note" matInput
                                                        placeholder="Note" maxlength="120"
                                                        onkeypress="if(this.value.length===120)return false;"></textarea>
                                                </mat-form-field>
                                                </div>
                                                <span
                                                    *ngIf="tableData==='value' && element[tableData]">{{element[tableData]}}</span>
                                                <mat-form-field class="field" appearance="fill" class="dover-form"
                                                    *ngIf="tableData==='author' && !element[tableData]">
                                                    <mat-select formControlName="author" placeholder="Added By">
                                                        <mat-option *ngFor="let item of element['usersList']"
                                                            [value]="item">
                                                            <span>{{item?.first | titlecase}}</span>
                                                            <span *ngIf="item?.middle">&nbsp;</span>
                                                            <span>{{item?.middle}}</span>
                                                            <span *ngIf="item?.last">&nbsp;</span>
                                                            <span>{{item?.last}}</span>
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                                <span
                                                    *ngIf="tableData==='author' && element[tableData]">{{element[tableData]}}</span>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="pageType!=='vitals'">
                                <div [ngClass]="{'dover-accordion-sub': pageType==='dover-accordion'}">
                                    <div *ngIf="tableData==='sourceTimestamp' && pageType!=='dover-accordion'"><span
                                            class="border-left-red {{element['severity']}}"></span></div>
                                    <span *ngIf="tableData==='sourceTimestamp'" class="pl-1">
                                        {{element[tableData] | date : 'shortTime'}}
                                    </span>
                                    <span
                                        *ngIf="(tableData!=='sourceTimestamp' && pageType==='dover-accordion') || (tableData!=='sourceTimestamp' && tableData!=='entityName')">
                                        <span *ngIf="tableData==='Respiratory Rate'">
                                            <img class=" mx-100 default-img list-img-inn" alt="Flag"
                                                *ngIf="element['attrValid']"
                                                src="../../assets/images/table-flag-dover.svg" title="Flag" />
                                        </span>
                                        {{element[tableData]}}
                                    </span>
                                    <span *ngIf="tableData==='entityName' && pageType!=='dover-accordion'"
                                        (click)="entityNameRoute(element)" class="hyper-link">
                                        {{element[tableData]}}
                                    </span>
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                </ng-container>
                <ng-container *ngIf="columnHeader[tableData] == 'Action'">
                    <tr>
                        <th scope="col" mat-header-cell *matHeaderCellDef>{{columnHeader[tableData]}}</th>
                    </tr>
                    <tr>
                        <td mat-cell *matCellDef="let element;index as i;"
                            [ngClass]="{'disabled': element['status']==='Acknowledged'}"
                            (mouseenter)="element['hover']=true;" (mouseleave)="element['hover']=false;">
                            <ng-container class="d-flex  cursor">
                                <div class="d-flex" [ngClass]="{'dover-accordion-sub': pageType==='dover-accordion'}">
                                    <span *ngIf="element['hover']">
                                        <span *ngIf="pageType==='doverAlert'" class="d-flex position-relative gap20">
                                            <a (click)="onActionClick(element,'actionTaken',i)"
                                                title="Action Taken"><img
                                                    src="../../../../assets/images/dover-add-icon.svg"
                                                    title="Action Taken" alt="Action Taken" class="h-15 cursor"></a>
                                            <a (click)="onActionClick(element,'invalid',i)" title="Mark As Invalid"><img
                                                    src="../../../../assets/images/dover-close-icon.svg"
                                                    title="Mark As Invalid" alt="Invalid" class="h-15 cursor"></a>
                                        </span>
                                        <span *ngIf="pageType==='vitals'" class="d-flex position-relative gap20">
                                            <a (click)="onActionClick(element,'submit',i)" title="Submit"><img
                                                    src="../../../../assets/images/dover-add-icon.svg" title="Submit"
                                                    alt="Submit" class="h-15 cursor"></a>
                                            <a (click)="onActionClick(element,'cancel',i)" title="Cancel"><img
                                                    src="../../../../assets/images/dover-close-icon.svg" title="Cancel"
                                                    alt="Cancel" class="h-15 cursor"></a>
                                            <a (click)="editClick(element, i)" title="Edit"
                                                *ngIf="element['value'] && !element['attrValid']"><img
                                                    src="../../../../assets/images/edit-icon-inside-dropdown.svg"
                                                    title="Edit" alt="Edit" class="h-15 cursor"></a>
                                        </span>
                                    </span>
                                    <span *ngIf="!element['hover'] && pageType!=='dover-accordion'">
                                        <a><img src="../../../../assets/images/dover-three-dot.svg" alt="more"
                                                class="dots3 cursor"></a>
                                    </span>
                                </div>
                            </ng-container>
                        </td>
                    </tr>

                </ng-container>
            </ng-container>
            <ng-container *ngIf="pageType!=='dover-accordion'">
                <tr mat-header-row *matHeaderRowDef="objectKeys(columnHeader)"></tr>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: objectKeys(columnHeader);"
                [ngClass]="{'dover-tr-hover': row['hover']}"></tr>
        </table>
        <app-standard-pagination [pagination]="pager" backgroundColor="'#f8f8f8'"
            *ngIf="dataSource?.data?.length && pager && pager?.pages?.length > 1" (paginationAction)="stepChange($event)">
        </app-standard-pagination>
    </div>
    <div [hidden]="dataSource.data.length>0 || loadStatus" class="no-records">
        <div class="d-flex justify-content-center align-items-center vh-75">
            <div class="text-center image-style">
                <img src="../../../assets/images/nodata.svg" class="w-10" alt="no-data">
            </div>
        </div>
    </div>
</div>